/* Tarjetas de visita y de agradecimiento · Imprimirlo
 * Sustituye a Live Product Options. Dos caminos según la opción "Diseño":
 *   - "Tengo el Diseño"  -> sube las dos caras (la de detrás es opcional)
 *   - "Necesito que..."  -> formulario de encargo con los datos de la tarjeta
 * Todo viaja con la subida nativa de Shopify (multipart), sin apps.
 */
(function () {
  'use strict';

  // si el diseñador está abierto, parte de la ficha (cantidad, plazo, botón) vive dentro de él: se busca también ahí
  function $(r, s) { return r.querySelector(s) || (r.__extra ? r.__extra.querySelector(s) : null); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function money(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  function fmt(n, d) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: d || 0, maximumFractionDigits: d == null ? 1 : d }); }

  // "8,5 × 5,5 cm" -> {w: 85, h: 55} en mm
  function medidaDe(texto) {
    var m = String(texto).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
    if (!m) return null;
    return { w: parseFloat(m[1].replace(',', '.')) * 10, h: parseFloat(m[2].replace(',', '.')) * 10 };
  }

  var ESTILOS = [
    { id: 'clasica', t: 'Clásica y sobria', d: 'Fondo blanco, tipografía seria, mucho aire' },
    { id: 'moderna', t: 'Moderna y limpia', d: 'Minimalista, con el logo mandando' },
    { id: 'color', t: 'Con color y fuerza', d: 'Fondo a color, que se vea desde lejos' },
    { id: 'elegante', t: 'Elegante', d: 'Detalles finos, aire de estudio o consultoría' },
    { id: 'web', t: 'Como mi web', d: 'Cogemos los colores y la letra de tu web' }
  ];

  /* LA PALABRA DEL PRODUCTO. La misma ficha sirve para tarjetas y, desde el
     26/09, para flyers (sustituye a Upload-Lift en esa ficha): lo único que
     cambia en los textos es cómo se llama la cosa. */
  var PALABRAS = {
    tarjeta: { una: 'tarjeta', varias: 'tarjetas', de: 'de la tarjeta' },
    flyer: { una: 'flyer', varias: 'flyers', de: 'del flyer' },
    calendario: { una: 'calendario', varias: 'calendarios', de: 'de la pegatina' },
    felicitacion: { una: 'tarjeta', varias: 'tarjetas', de: 'de la tarjeta' }
  };

  function Tarjetas(root) {
    this.root = root;
    this.cfg = JSON.parse($(root, '[data-tjs-config]').textContent);
    this.pal = PALABRAS[this.cfg.tipo] || PALABRAS.tarjeta;
    this.caja = medidaDe(this.cfg.medida);
    this.archivos = {};
    this.estilo = null;
    this.busy = false;
    this.libre = null;          // «otra cantidad» tecleada (null = una de las de la escalera)
    this.pintarEstilos();
    this.montarOpciones();
    this.montarDisenador();
    this.bind();
    this.actualizar();
  }

  /* ---------- variante y modo ---------- */
  Tarjetas.prototype.variante = function () {
    var v = this.cfg.variantes;
    // con selector propio (flyers) manda lo que se ha elegido en él
    if (this.sel) return this.varianteCon(-1, null);
    var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (campo && campo.value) {
      var enc = v.filter(function (x) { return String(x.id) === String(campo.value); })[0];
      if (enc) return enc;
    }
    var elegidas = [];
    document.querySelectorAll('variant-selects select, variant-radios input:checked, .product-form__input select, .product-form__input input:checked')
      .forEach(function (el) { if (el.value) elegidas.push(el.value.trim()); });
    if (elegidas.length) {
      var m = v.filter(function (x) {
        return x.opts.every(function (o, i) { return elegidas[i] == null || o === elegidas[i]; });
      })[0];
      if (m) return m;
    }
    return v[0] || null;
  };

  // "Tengo el Diseño" -> 'tengo' · "Necesito que hagáis el Diseño" -> 'encargo'
  Tarjetas.prototype.modo = function () {
    var v = this.variante();
    if (!v) return 'tengo';
    var encargo = v.opts.some(function (o) { return /necesito|hag[áa]is|hagais/i.test(o); });
    return encargo ? 'encargo' : 'tengo';
  };

  /* La medida: fija en tarjetas; en flyers sale de la opción de tamaño de la
     variante elegida, «A5 (14.8 X 21 cm)» → 148 × 210 mm. */
  Tarjetas.prototype.medida = function () {
    if (this.cfg.medida) return { caja: medidaDe(this.cfg.medida), texto: this.cfg.medida };
    var v = this.variante();
    if (!v) return { caja: null, texto: '' };
    for (var i = 0; i < v.opts.length; i++) {
      var c = medidaDe(v.opts[i]);
      if (c) return { caja: c, texto: fmt(c.w / 10) + ' × ' + fmt(c.h / 10) + ' cm' };
    }
    return { caja: null, texto: '' };
  };

  // ¿a una cara o a dos? null si la ficha no lo pregunta (tarjetas)
  Tarjetas.prototype.caras = function () {
    var v = this.variante();
    if (!v) return null;
    for (var i = 0; i < v.opts.length; i++) {
      var m = String(v.opts[i]).match(/(\d)\s*caras?/i);
      if (m) return parseInt(m[1], 10);
    }
    return null;
  };

  /* CALENDARIOS: la cantidad no es una variante, es la cantidad de la línea,
     de 25 en 25 (vienen en cajas de 25) y como mínimo 25. Lo que se teclee se
     sube al múltiplo de 25 siguiente al salir del campo. */
  Tarjetas.prototype.uds = function () {
    var paso = this.cfg.paso;
    if (!paso) return 1;
    var i = $(this.root, '[data-uds]');
    var n = i ? parseInt(String(i.value).replace(/\D/g, ''), 10) : paso;
    if (!(n > 0)) n = paso;
    return Math.max(paso, Math.ceil(n / paso) * paso);
  };

  /* EL PRECIO POR UNIDAD SEGÚN EL TRAMO (calendarios). El descuento lo pone
     Shopify en el carrito; aquí se enseña ya aplicado para que el botón diga
     lo mismo que va a cobrar. Sin tramos, el precio de la variante. */
  Tarjetas.prototype.precioUd = function (n) {
    var v = this.variante(), t = this.cfg.tramos;
    var p = v ? v.precio : 0;
    if (t) t.forEach(function (x) { if (n >= x[0]) p = x[1]; });
    return p;
  };

  Tarjetas.prototype.pintarTramos = function () {
    var self = this, caja = $(this.root, '[data-tramos]'), t = this.cfg.tramos;
    if (!caja || !t) return;
    var n = this.uds();
    /* Los botones se crean UNA vez y luego solo se marca el que toca. Si se
       rehicieran en cada repintado, el que se está pulsando desaparecería:
       al pulsar después de escribir, el campo pierde el foco, se repinta todo
       y el clic cae en un botón que ya no existe. */
    if (caja.children.length !== t.length) {
      caja.innerHTML = '';
      t.forEach(function (x, i) {
        var sig = t[i + 1];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tjs-op__b';
        b.innerHTML = '<b>' + (sig ? x[0] + '–' + (sig[0] - 1) : x[0] + ' o más') + '</b>' +
          '<em>' + money(x[1]) + '</em><small>cada uno</small>';
        b.addEventListener('click', function () {
          var ui = $(self.root, '[data-uds]');
          if (ui) ui.value = String(x[0]);
          self.actualizar();
        });
        caja.appendChild(b);
      });
    }
    t.forEach(function (x, i) {
      var sig = t[i + 1], on = n >= x[0] && (!sig || n < sig[0]);
      caja.children[i].classList.toggle('is-on', on);
      caja.children[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var res = $(this.root, '[data-tramo-resumen]');
    if (res) {
      var pu = this.precioUd(n);
      var txt = '<b>' + money(pu * n) + '</b> · ' + n + ' ' + this.pal.varias + ' a ' + money(pu) + ' cada uno · IVA incluido';
      /* EL SIGUIENTE TRAMO, SI ESTÁ CERCA. Sin porcentajes (Xavi): se dice
         cuántos faltan y a cuánto saldrían, y el cliente decide. */
      var sig = t.filter(function (x) { return x[0] > n; })[0];
      if (sig && sig[0] - n <= Math.max(50, n * 0.5)) {
        txt += '<br>Con ' + sig[0] + ' te salen a ' + money(sig[1]) + ' cada uno (' + money(sig[1] * sig[0]) + ' en total).';
      }
      res.innerHTML = txt;
      res.hidden = false;
    }
  };

  Tarjetas.prototype.cantidad = function () {
    if (this.cfg.paso) return this.uds();
    if (this.libre && this.iUds >= 0) return this.libre;
    var v = this.variante();
    if (!v) return null;
    for (var i = 0; i < v.opts.length; i++) {
      var m = String(v.opts[i]).match(/^\s*(\d+)\s*$/);
      if (m) return parseInt(m[1], 10);
    }
    return null;
  };

  /* ---------- selector propio de los flyers ----------
   *
   * Xavi, viendo la ficha en el móvil: «no sigue la dinámica de los otros
   * productos, hazlo más visual con precios y plazos». Eran las píldoras de
   * Dawn —siete cantidades, dos caras, cuatro tamaños— sin un solo precio
   * hasta ir clicando. Aquí va como en las pegatinas: el tamaño DIBUJADO a
   * escala entre ellos, cada opción con su precio total, la escalera de
   * cantidades con el precio por unidad, y la fecha de entrega arriba y abajo.
   *
   * Solo se monta en flyers (`data-opciones` solo sale ahí). Las tarjetas y el
   * calendario siguen con lo de antes.
   */
  function udsDe(val) { var m = String(val).match(/^\s*(\d+)\s*$/); return m ? parseInt(m[1], 10) : 0; }
  function carasDe(val) { var m = String(val).match(/(\d)\s*caras?/i); return m ? parseInt(m[1], 10) : 0; }
  // «0,21 €», y con tres decimales cuando la unidad baja de 10 céntimos
  function porUd(c, uds) {
    var e = c / 100 / Math.max(1, uds);
    return e.toLocaleString('es-ES', { style: 'currency', currency: 'EUR',
      minimumFractionDigits: 2, maximumFractionDigits: e < 0.1 ? 3 : 2 });
  }

  /* «OTRA CANTIDAD» (Xavi, 29/10/2026: «en tarjetas y flyers pon la opción de otras cantidades»). Misma regla que los llaveros y la silicona:
     se cobra el PRECIO POR UNIDAD DEL ESCALÓN DE ABAJO × las unidades que pide (300 tarjetas = el precio por unidad de las 200 × 300). Va al carrito
     como la variante del escalón de abajo + el producto «suplemento» (1 € por unidad) con los euros que sobran. Sin tope por arriba: por encima
     del último escalón, el precio por unidad del último. Por debajo del primero, presupuesto por WhatsApp. */
  Tarjetas.prototype.escalones = function () {
    var self = this, out = [];
    if (this.iUds < 0 || !this.sel) return out;
    this.valores[this.iUds].forEach(function (val) {
      var v2 = self.varianteCon(self.iUds, val);
      if (v2) out.push({ cant: udsDe(val), val: val, precio: v2.precio });
    });
    return out.sort(function (a, b) { return a.cant - b.cant; });
  };
  Tarjetas.prototype.libreCalc = function (n) {
    var tiers = this.escalones(), base = null;
    tiers.forEach(function (t) { if (t.cant <= n) base = t; });
    if (!base || !(n > 0)) return null;
    var unit = base.precio / base.cant, sobran = n - base.cant, extraEur = Math.round(sobran * unit / 100);
    return { base: base.cant, val: base.val, sobran: sobran, unit: unit, extraEur: extraEur, extra: extraEur * 100, total: base.precio + extraEur * 100, uds: n };
  };
  Tarjetas.prototype.libreInfo = function () {
    return this.libre && this.iUds >= 0 ? this.libreCalc(this.libre) : null;
  };
  // el precio de la variante elegida MÁS las unidades extra de la cantidad libre (céntimos)
  Tarjetas.prototype.precioBase = function () {
    var v = this.variante(), l = this.libreInfo();
    return v ? v.precio + (l ? l.extra : 0) : 0;
  };

  Tarjetas.prototype.montarOpciones = function () {
    var self = this, caja = $(this.root, '[data-opciones]');
    var nombres = this.cfg.opciones || [];
    if (!caja || !nombres.length || !this.cfg.variantes.length) return;
    this.valores = nombres.map(function (_, i) {
      var out = [];
      self.cfg.variantes.forEach(function (v) {
        if (v.opts[i] != null && out.indexOf(v.opts[i]) === -1) out.push(v.opts[i]);
      });
      return out;
    });
    // qué opción es cada cosa, sin fiarse del orden en que estén en Shopify
    this.iUds = this.iCaras = this.iTam = this.iOtro = -1;
    this.valores.forEach(function (vals, i) {
      if (vals.every(udsDe)) self.iUds = i;
      else if (vals.every(carasDe)) self.iCaras = i;
      else if (vals.every(medidaDe)) self.iTam = i;
      else self.iOtro = i;    // acabado (laminado de las tarjetas)
    });
    // la tabla de cantidad × plazo parte del plazo económico, que es el precio de la ficha
    if (this.cfg.plazos && !this.plazo) this.plazo = 'eco';
    /* De salida, el A5 a 1 cara y 100 unidades: la ficha lo llama «el más
       popular» y es el precio que dan las preguntas frecuentes. Si no existe,
       la primera variante. */
    this.sel = this.cfg.variantes[0].opts.slice();
    var quiero = this.sel.slice();
    if (this.iTam >= 0) this.valores[this.iTam].forEach(function (x) { if (/^\s*A5\b/i.test(x)) quiero[self.iTam] = x; });
    if (this.iUds >= 0) this.valores[this.iUds].forEach(function (x) { if (udsDe(x) === 100) quiero[self.iUds] = x; });
    // a 1 cara de salida (14/10): con 2 caras de salida, quien sube solo la de delante se encontraba el botón bloqueado («sube también la de detrás»)
    if (this.iCaras >= 0) this.valores[this.iCaras].forEach(function (x) { if (carasDe(x) === 1) quiero[self.iCaras] = x; });
    if (this.buscar(quiero)) this.sel = quiero;
    caja.hidden = false;
    this.pintarOpciones();
  };

  Tarjetas.prototype.buscar = function (sel) {
    return this.cfg.variantes.filter(function (v) {
      return sel.every(function (s, j) { return v.opts[j] === s; });
    })[0] || null;
  };
  // la variante elegida con una opción cambiada (i = -1: la elegida tal cual)
  Tarjetas.prototype.varianteCon = function (i, valor) {
    var sel = this.sel.slice();
    if (i >= 0) sel[i] = valor;
    return this.buscar(sel);
  };

  Tarjetas.prototype.pintarOpciones = function () {
    var self = this, caja = $(this.root, '[data-opciones]');
    if (!caja || !this.sel) return;
    if (this.libre && this.iUds >= 0) {           // la variante sigue al escalón de abajo si cambian el tamaño, las caras o el acabado
      var lc = this.libreCalc(this.libre);
      if (lc) this.sel[this.iUds] = lc.val; else this.libre = null;
    }
    caja.innerHTML = '';

    var fila = function (titulo, i, clase, pinta) {
      if (i < 0 || self.valores[i].length < 2) return;
      var t = document.createElement('p');
      t.className = 'tjs-op__t';
      t.textContent = titulo;
      caja.appendChild(t);
      var f = document.createElement('div');
      f.className = 'tjs-op__fila ' + clase;
      self.valores[i].forEach(function (val) {
        var w = self.varianteCon(i, val);
        var b = document.createElement('button');
        b.type = 'button';
        var on = self.sel[i] === val;
        b.className = 'tjs-op__b' + (on ? ' is-on' : '');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!w) { b.disabled = true; b.title = 'No disponible con lo que has elegido'; }
        pinta(b, val, w);
        b.addEventListener('click', function () {
          self.sel[i] = val;
          self.pintarOpciones();
          self.actualizar();
        });
        f.appendChild(b);
      });
      caja.appendChild(f);
    };

    // EL TAMAÑO, A ESCALA. Un «A5 (14.8 X 21 cm)» nadie se lo imagina; el
    // papelito dibujado al lado del A4, sí.
    var mayor = 0;
    if (this.iTam >= 0) this.valores[this.iTam].forEach(function (x) {
      var m = medidaDe(x); if (m) mayor = Math.max(mayor, m.w, m.h);
    });
    fila('Tamaño — a escala entre ellos', this.iTam, 'es-tams', function (b, val, w) {
      var m = medidaDe(val);
      var fig = document.createElement('span');
      fig.className = 'tjs-op__fig';
      var hoja = document.createElement('i');
      var k = 58 / (mayor || 297);
      hoja.style.width = Math.max(12, Math.round(m.w * k)) + 'px';
      hoja.style.height = Math.max(12, Math.round(m.h * k)) + 'px';
      fig.appendChild(hoja);
      b.appendChild(fig);
      var nom = document.createElement('b');
      nom.textContent = String(val).split('(')[0].trim();
      b.appendChild(nom);
      var med = document.createElement('small');
      med.className = 'tjs-op__med';
      med.textContent = fmt(m.w / 10) + ' × ' + fmt(m.h / 10) + ' cm';
      b.appendChild(med);
      if (w) {
        var p = document.createElement('em');
        p.textContent = money(w.precio);
        b.appendChild(p);
      }
    });

    fila('Impresión', this.iCaras, 'es-caras', function (b, val, w) {
      var n = carasDe(val);
      var fig = document.createElement('span');
      fig.className = 'tjs-op__caras';
      fig.innerHTML = n === 2 ? '<i></i><i></i>' : '<i></i><i class="es-blanca"></i>';
      b.appendChild(fig);
      var nom = document.createElement('b');
      nom.textContent = n === 2 ? 'A 2 caras' : 'A 1 cara';
      b.appendChild(nom);
      var sub = document.createElement('small');
      sub.className = 'tjs-op__med';
      sub.textContent = n === 2 ? 'delante y detrás' : 'detrás en blanco';
      b.appendChild(sub);
      if (w) {
        var p = document.createElement('em');
        p.textContent = money(w.precio);
        b.appendChild(p);
      }
    });

    // EL ACABADO (tarjetas): sin laminar, mate o brillo, cada uno con su precio a la cantidad elegida
    if (this.cfg.plazos) fila(this.cfg.opciones[this.iOtro] || 'Acabado', this.iOtro, 'es-acabado', function (b, val, w) {
      var nom = document.createElement('b');
      nom.textContent = String(val);
      b.appendChild(nom);
      if (w) {
        var p = document.createElement('em');
        p.textContent = money(w.precio);
        b.appendChild(p);
      }
    });

    if (this.cfg.plazos) this.pintarTablaPlazos(caja);
    /* LA ESCALERA DE CANTIDADES: el total en grande, que es lo que se paga, y
       debajo cuánto sale cada uno. Sin porcentajes de ahorro —Xavi los quitó
       de las pegatinas: «la gente solo quiere saber el precio»—; el €/ud
       bajando fila a fila ya lo cuenta. */
    else fila('Cantidad', this.iUds, 'es-cants', function (b, val, w) {
      var n = udsDe(val);
      var nom = document.createElement('b');
      nom.textContent = n.toLocaleString('es-ES');
      b.appendChild(nom);
      if (w) {
        var p = document.createElement('em');
        p.textContent = money(w.precio);
        b.appendChild(p);
        var u = document.createElement('small');
        u.textContent = porUd(w.precio, n) + '/ud';
        b.appendChild(u);
      }
    });

    var v = this.variante();
    if (v) {
      var uds = this.cantidad() || 1, caras = this.caras();
      var tam = this.iTam >= 0 ? this.sel[this.iTam] : '';
      var rec = this.recargo();
      var res = document.createElement('p');
      res.className = 'tjs-op__resumen';
      res.innerHTML = '<b>' + money(this.precioBase() + (rec ? rec.precio : 0)) + '</b> · ' + uds.toLocaleString('es-ES') + ' ' + this.pal.varias +
        (tam ? ' ' + String(tam).split('(')[0].trim() : '') +
        (caras ? ' a ' + caras + (caras === 2 ? ' caras' : ' cara') : '') +
        (uds > 1 ? ' · ' + porUd(this.precioBase() + (rec ? rec.precio : 0), uds) + ' cada ' + (this.cfg.tipo === 'tarjeta' ? 'una' : 'uno') : '') + ' · IVA incluido';
      caja.appendChild(res);
    }
    this.pintarPlazo(caja);
  };

  /* CUÁNDO LO TIENE. La calcula entrega.js con los días de la configuración y
     va dos veces: arriba del todo, en la caja verde de siempre, y debajo del
     precio, que es donde se decide la compra. Cuenta impresiones (flyers ×
     caras) por si el taller pone tope diario. */
  Tarjetas.prototype.pintarPlazo = function (caja) {
    var cfg = this.cfg.entrega;
    if (!cfg || !window.Entrega) return;
    var imp = (this.cantidad() || 0) * (this.caras() || 1);
    var txt = this.cfg.plazos && Entrega.textoPlazo ? Entrega.textoPlazo(cfg, this.plazo || 'eco', null, imp) : Entrega.texto(cfg, false, null, imp);
    var arriba = $(this.root, '[data-entrega-arriba]');
    if (arriba) { arriba.innerHTML = txt; arriba.hidden = false; }
    if (caja) {
      var p = document.createElement('p');
      p.className = 'tjs-op__fecha';
      p.innerHTML = txt;
      caja.appendChild(p);
    }
  };

  /* TABLA DE CANTIDAD × PLAZO (Xavi, 08/10: «todo lo que sea imprenta, este sistema», el de los imanes).
       Económico (6-7 días): el precio de la ficha.      Normal (4-5): + 5 % (producto «plazo normal», por euros).
       Express (2-3): + 30 %, mínimo 5 € (producto «imprenta · entrega urgente», por euros).
     Pulsar una celda elige a la vez la cantidad y el plazo. Las fechas son SIEMPRE estimadas y así se dice. */
  function cercano(lista, objetivo) {
    var mejor = null;
    (lista || []).forEach(function (x) { if (!mejor || Math.abs(x.precio - objetivo) < Math.abs(mejor.precio - objetivo)) mejor = x; });
    return mejor;
  }
  Tarjetas.prototype.recargoDe = function (base, plazo) {
    var p = this.cfg.plazos;
    if (!p || !(base > 0)) return null;
    if (plazo === 'normal') return cercano(p.normal, Math.max(100, Math.round(base * 0.05 / 100) * 100));
    if (plazo === 'express') return cercano(p.express, Math.max(500, Math.round(base * 0.30 / 100) * 100));
    return null;
  };
  // la línea de recargo que toca AHORA ({id, precio}) o null con el plazo económico
  Tarjetas.prototype.recargo = function () {
    var v = this.variante();
    return v ? this.recargoDe(this.precioBase(), this.plazo) : null;
  };
  Tarjetas.prototype.pintarTablaPlazos = function (caja) {
    var self = this, cfg = this.cfg.entrega;
    if (!this.plazo) this.plazo = 'eco';
    var t3 = document.createElement('p'); t3.className = 'tjs-op__t'; t3.textContent = 'Cantidad y plazo de entrega'; caja.appendChild(t3);
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function rangoTxt(r) {
      if (r[0].toDateString() === r[1].toDateString()) return r[0].getDate() + ' ' + meses[r[0].getMonth()];
      return r[0].getMonth() === r[1].getMonth()
        ? r[0].getDate() + '–' + r[1].getDate() + ' ' + meses[r[1].getMonth()]
        : r[0].getDate() + ' ' + meses[r[0].getMonth()] + ' – ' + r[1].getDate() + ' ' + meses[r[1].getMonth()];
    }
    var tabla = document.createElement('div'); tabla.className = 'tjs-tp'; tabla.setAttribute('role', 'group');
    tabla.setAttribute('aria-label', 'Cantidad y plazo de entrega estimado');
    [['Uds.', ''], ['Económico', '6-7 días'], ['Normal', '4-5 días'], ['Express', '2-3 días']].forEach(function (h, i) {
      var c = document.createElement('div'); c.className = 'tjs-tp__h' + (i === 3 ? ' is-urg' : '');
      c.innerHTML = '<b>' + h[0] + '</b>' + (h[1] ? '<small>' + h[1] + '</small>' : ''); tabla.appendChild(c);
    });
    var cants = this.valores[this.iUds].slice().sort(function (a, b) { return udsDe(a) - udsDe(b); });
    cants.forEach(function (val) {
      var uds = udsDe(val), v2 = self.varianteCon(self.iUds, val);
      if (!v2) return;
      var esSel = !self.libre && self.sel[self.iUds] === val, base = v2.precio;
      var q = document.createElement('div'); q.className = 'tjs-tp__q'; q.innerHTML = '<b>' + uds.toLocaleString('es-ES') + '</b>'; tabla.appendChild(q);
      function celda(plazo, total) {
        var on = esSel && self.plazo === plazo;
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'tjs-tp__c' + (plazo === 'express' ? ' is-urg' : '') + (on ? ' is-on' : '');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var fecha = cfg && window.Entrega && Entrega.rangoPlazo ? rangoTxt(Entrega.rangoPlazo(cfg, plazo, null, uds * (self.caras() || 1))) : '';
        b.innerHTML = '<b>' + money(total) + '</b><small>' + porUd(total, uds) + '/ud</small>' + (fecha ? '<span>' + fecha + '</span>' : '');
        b.addEventListener('click', function () {
          self.sel[self.iUds] = val; self.plazo = plazo; self.libre = null;
          self.pintarOpciones(); self.actualizar();
        });
        tabla.appendChild(b);
      }
      celda('eco', base);
      [['normal', 'normal'], ['express', 'express']].forEach(function (pz) {
        var rc = self.recargoDe(base, pz[0]);
        if (rc) celda(pz[1], base + rc.precio);
        else { var v0 = document.createElement('div'); v0.className = 'tjs-tp__no'; v0.textContent = '—'; tabla.appendChild(v0); }
      });
    });
    caja.appendChild(tabla);
    this.pintarLibre(caja, cants, cfg, rangoTxt);
    var nota = document.createElement('p'); nota.className = 'tjs-muted tjs-tp__nota';
    nota.innerHTML = '<b>Fechas de entrega estimadas</b>, en días laborables a península, contando desde que el diseño está listo y ' +
      'con el pedido hecho antes de las 12:00. No son una fecha garantizada: pueden variar por causas ajenas al taller ' +
      '(transportista, incidencias). Precios con IVA incluido.';
    caja.appendChild(nota);
  };

  // «¿Otra cantidad?»: un campo, y debajo su fila con los tres plazos como las demás. Se confirma al dejar de teclear (0,6 s) o al salir del campo.
  Tarjetas.prototype.pintarLibre = function (caja, cants, cfg, rangoTxt) {
    var self = this, tiers = this.escalones(), min = tiers.length ? tiers[0].cant : 0;
    if (!tiers.length) return;
    var bloque = document.createElement('div'); bloque.className = 'tjs-libre';
    var lab = document.createElement('label'); lab.className = 'tjs-libre__l';
    lab.appendChild(document.createTextNode('¿Otra cantidad? '));
    var inp = document.createElement('input'); inp.type = 'text'; inp.inputMode = 'numeric'; inp.autocomplete = 'off'; inp.maxLength = 6;
    inp.className = 'tjs-libre__i'; inp.setAttribute('aria-label', 'Otra cantidad'); inp.placeholder = 'p. ej. ' + (tiers.length > 1 ? Math.round((tiers[0].cant + tiers[1].cant) / 2 / 10) * 10 : tiers[0].cant + 50);
    if (this.libre) inp.value = String(this.libre); else if (this._bajo) inp.value = String(this._bajo);
    lab.appendChild(inp); lab.appendChild(document.createTextNode(' uds')); bloque.appendChild(lab);
    var msg = document.createElement('p'); msg.className = 'tjs-libre__m tjs-muted'; msg.setAttribute('aria-live', 'polite'); bloque.appendChild(msg);
    caja.appendChild(bloque);

    function aplicar() {
      var n = parseInt(inp.value.replace(/\D/g, ''), 10);
      var antes = self.libre;
      if (!(n >= min)) { self.libre = null; self._bajo = n > 0 ? n : 0; if (antes === null && inp.value === '') return; }
      else if (tiers.some(function (t) { return t.cant === n; })) { self._bajo = 0; self.sel[self.iUds] = tiers.filter(function (t) { return t.cant === n; })[0].val; self.libre = null; inp.value = ''; }
      else { self.libre = n; self._bajo = 0; }
      self._foco = !!inp.value;
      self.pintarOpciones(); self.actualizar();
    }
    var t0 = null;
    inp.addEventListener('input', function () { inp.value = inp.value.replace(/\D/g, '').slice(0, 6); clearTimeout(t0); t0 = setTimeout(aplicar, 600); });
    inp.addEventListener('change', function () { clearTimeout(t0); aplicar(); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(t0); aplicar(); } });

    var txt = inp.value.replace(/\D/g, ''), n0 = parseInt(txt, 10);
    if (!txt) { msg.textContent = 'Desde ' + min.toLocaleString('es-ES') + ' ' + this.pal.varias + '. Entre dos escalones se cobra el precio por unidad del escalón de abajo.'; }
    else if (n0 < min) {
      var a = document.createElement('a'); a.href = 'https://wa.me/34934358257?text=' + encodeURIComponent('Hola, quiero presupuesto de ' + txt + ' ' + this.pal.varias + ' (' + (document.querySelector('h1') || document).textContent.replace(/\s+/g, ' ').trim() + ')');
      a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'escríbenos por WhatsApp';
      msg.appendChild(document.createTextNode('El mínimo es de ' + min.toLocaleString('es-ES') + '; para menos, ')); msg.appendChild(a); msg.appendChild(document.createTextNode(' y te hacemos presupuesto.'));
    }
    var l = this.libreInfo();
    if (!l) { if (this._foco) { this._foco = false; inp.focus(); var e1 = inp.value.length; try { inp.setSelectionRange(e1, e1); } catch (e) { /* sin selección */ } } return; }
    msg.textContent = l.uds.toLocaleString('es-ES') + ' ' + this.pal.varias + ' × ' + porUd(l.unit, 1) + ' (el precio por unidad del escalón de ' + l.base.toLocaleString('es-ES') + ') = ' + money(l.total) + '. ';
    var sig = tiers.filter(function (t) { return t.cant > l.uds; })[0];
    if (sig && sig.precio <= l.total) {
      var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'tjs-link'; bt.textContent = 'Elegir las ' + sig.cant.toLocaleString('es-ES');
      msg.appendChild(document.createTextNode('Las ' + sig.cant.toLocaleString('es-ES') + ' salen a ' + money(sig.precio) + ', menos que esto. ')); msg.appendChild(bt);
      bt.addEventListener('click', function () { self.libre = null; self.sel[self.iUds] = sig.val; self.pintarOpciones(); self.actualizar(); });
    }
    var tabla = document.createElement('div'); tabla.className = 'tjs-tp tjs-tp--libre'; tabla.setAttribute('role', 'group'); tabla.setAttribute('aria-label', 'Plazo de entrega para ' + l.uds + ' unidades');
    var q = document.createElement('div'); q.className = 'tjs-tp__q'; q.innerHTML = '<b>' + l.uds.toLocaleString('es-ES') + '</b>'; tabla.appendChild(q);
    function celdaL(plazo, total) {
      var on = self.plazo === plazo;
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'tjs-tp__c' + (plazo === 'express' ? ' is-urg' : '') + (on ? ' is-on' : '');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var fecha = cfg && window.Entrega && Entrega.rangoPlazo ? rangoTxt(Entrega.rangoPlazo(cfg, plazo, null, l.uds * (self.caras() || 1))) : '';
      b.innerHTML = '<b>' + money(total) + '</b><small>' + porUd(total, l.uds) + '/ud</small>' + (fecha ? '<span>' + fecha + '</span>' : '');
      b.addEventListener('click', function () { self.plazo = plazo; self.pintarOpciones(); self.actualizar(); });
      tabla.appendChild(b);
    }
    celdaL('eco', l.total);
    ['normal', 'express'].forEach(function (pz) {
      var rc = self.recargoDe(l.total, pz);
      if (rc) celdaL(pz, l.total + rc.precio);
      else { var v0 = document.createElement('div'); v0.className = 'tjs-tp__no'; v0.textContent = '—'; tabla.appendChild(v0); }
    });
    caja.appendChild(tabla);
    if (this._foco) { this._foco = false; inp.focus(); var e2 = inp.value.length; try { inp.setSelectionRange(e2, e2); } catch (e) { /* sin selección */ } }
  };

  /* ---------- pintado ---------- */
  Tarjetas.prototype.pintarEstilos = function () {
    var self = this, cont = $(this.root, '[data-estilos]');
    if (!cont) return;
    cont.innerHTML = '';
    ESTILOS.forEach(function (e) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tjs-estilo'; b.dataset.estilo = e.id;
      b.innerHTML = '<b>' + e.t + '</b><span>' + e.d + '</span>';
      b.addEventListener('click', function () {
        self.estilo = self.estilo === e.id ? null : e.id;
        $$(cont, '.tjs-estilo').forEach(function (x) {
          x.classList.toggle('is-sel', x.dataset.estilo === self.estilo);
        });
        self.actualizar();
      });
      cont.appendChild(b);
    });
  };

  Tarjetas.prototype.bind = function () {
    var self = this, r = this.root;
    $$(r, '[data-archivo-caja]').forEach(function (caja) {
      var clave = caja.dataset.archivoCaja;
      var input = $(caja, 'input[type="file"]'), drop = $(caja, '[data-drop]');
      drop.addEventListener('click', function (e) { e.preventDefault(); input.click(); });
      input.addEventListener('change', function () { self.cargar(clave, input.files[0]); input.value = ''; });
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
      });
      drop.addEventListener('drop', function (e) { self.cargar(clave, e.dataTransfer.files[0]); });
      $(caja, '[data-quitar]').addEventListener('click', function () {
        delete self.archivos[clave]; self.pintarArchivo(clave); self.actualizar();
      });
      $$(caja, '[data-fix]').forEach(function (b) {
        b.addEventListener('click', function () { self.arreglar(clave, b.dataset.fix); });
      });
      var des = $(caja, '[data-deshacer]');
      if (des) des.addEventListener('click', function () { self.deshacer(clave); });
    });
    $$(r, '[data-dato]').forEach(function (i) {
      i.addEventListener('input', function () { self.actualizar(); });
    });
    var repaso = $(r, '[data-repaso]');
    if (repaso) repaso.addEventListener('change', function () {
      self.actualizar();
      ['cara1', 'cara2'].forEach(function (k) { if (self.archivos[k]) self.pintarArchivo(k); });
    });
    this.root.addEventListener('click', function (e) {
      var ab = e.target.closest && e.target.closest('[data-abrir-ajuste]');
      if (ab) { self.abrirAjuste(ab.getAttribute('data-abrir-ajuste'), ab.hasAttribute('data-original')); return; }
      var b = e.target.closest && e.target.closest('[data-contratar-revision]');
      if (!b || !repaso) return;
      repaso.checked = true;
      repaso.dispatchEvent(new Event('change', { bubbles: true }));
      var w = $(self.root, '[data-repaso-wrap]');
      if (w && w.scrollIntoView) w.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var pdf2c = $(r, '[data-pdf2]');
    if (pdf2c) pdf2c.addEventListener('change', function () { self.actualizar(); });
    var ui = $(r, '[data-uds]');
    if (ui) {
      var poner = function (n) { ui.value = String(n); self.actualizar(); };
      ui.addEventListener('input', function () { self.actualizar(); });
      ui.addEventListener('blur', function () { poner(self.uds()); });
      $(r, '[data-uds-mas]').addEventListener('click', function () { poner(self.uds() + self.cfg.paso); });
      $(r, '[data-uds-menos]').addEventListener('click', function () { poner(Math.max(self.cfg.paso, self.uds() - self.cfg.paso)); });
    }
    $(r, '[data-add]').addEventListener('click', function () { self.alCarrito(); });
    var bPres = $(r, '[data-presupuesto]');
    if (bPres) bPres.addEventListener('click', function () { self.alCarrito(true); });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input, [name="id"]')) {
        setTimeout(function () { self.actualizar(); }, 30);
      }
    });
    window.addEventListener('popstate', function () { self.actualizar(); });
  };

  Tarjetas.prototype.flash = function (msg) {
    if (window.Cargando) Cargando.aviso(msg, 9000);
  };

  /* ---------- archivos ---------- */
  Tarjetas.prototype.cargar = async function (clave, file, extra) {
    if (!file) return;
    if (file.size > this.cfg.maxFileMb * 1048576) {
      return this.flash(file.name + ': pesa más de ' + this.cfg.maxFileMb + ' MB. Mándanoslo por WhatsApp.');
    }
    var dato = { file: file, name: file.name, px: null, transparente: null, arreglos: [] };
    if (extra) {
      dato.anterior = extra.anterior; dato.arreglos = extra.arreglos || [];
      dato.comparativa = extra.comparativa || null;
      dato.ajustado = !!extra.ajustado; dato.original = extra.original || null;
      if (dato.arreglos[dato.arreglos.length - 1] === 'bordes') {
        dato.pxCalidad = extra.anterior.pxCalidad || extra.anterior.px;
      }
    }
    /* El repaso de píxeles bloquea el hilo: primero se tapa la caja y se deja
       pintar, para que el cliente vea que está trabajando. */
    var destapar = function () {};
    if (window.Cargando && /png|jpe?g|webp/i.test(file.type)) {
      destapar = Cargando.velo($(this.root, '[data-archivo-caja="' + clave + '"]'),
        extra ? 'Aplicando el arreglo…' : 'Leyendo el archivo…',
        extra ? null : 'Comprobamos resolución y fondo');
      await Cargando.pinta();
    }
    if (/png|jpe?g|webp/i.test(file.type)) {
      try {
        var bmp = await createImageBitmap(file);
        var W = bmp.width, H = bmp.height;
        var e = Math.min(1, Math.sqrt(4e6 / (W * H)));
        var cw = Math.max(1, Math.round(W * e)), ch = Math.max(1, Math.round(H * e));
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(bmp, 0, 0, cw, ch);
        var d = ctx.getImageData(0, 0, cw, ch).data;
        var transp = false;
        for (var i = 3; i < d.length; i += 4) { if (d[i] < 250) { transp = true; break; } }
        var t = Math.min(1, 320 / Math.max(W, H));
        var th = document.createElement('canvas');
        th.width = Math.max(1, Math.round(W * t)); th.height = Math.max(1, Math.round(H * t));
        th.getContext('2d').drawImage(bmp, 0, 0, th.width, th.height);
        if (bmp.close) bmp.close();
        dato.px = [W, H]; dato.transparente = transp; dato.thumb = th;
        if (window.ImgArreglo) dato.plano = ImgArreglo.esPlano(th);
      } catch (err) { /* si no se puede leer, se sube igual */ }
    }
    destapar();
    this.archivos[clave] = dato;
    this.pintarArchivo(clave);
    this.actualizar();
    if (clave !== 'logo') this.leerPdfMm(clave);
    if (clave !== 'logo' && !dato.ajustado && /png|jpe?g|webp/i.test(file.type)) this.abrirAjuste(clave);
  };

  /* AJUSTE A LA TARJETA: el editor de assets/tarjeta-ajuste.js dentro de la ficha del archivo.
     Con imágenes se abre solo; con PDF, a petición. Si se aplica, el archivo del pedido es el ya
     ajustado (medida + 2 mm de sangre) y el original viaja aparte. */
  Tarjetas.prototype.abrirAjuste = function (clave, desdeOriginal) {
    var a = this.archivos[clave];
    if (!a || !window.TarjetaAjuste || !this.revisaTamano()) return;
    var caja = $(this.root, '[data-archivo-caja="' + clave + '"]');
    var ficha = $(caja, '[data-ficha]');
    if (!ficha) return;
    this.cerrarAjuste(clave);
    var host = document.createElement('div'); host.setAttribute('data-ajuste', clave);
    ficha.parentNode.insertBefore(host, ficha.nextSibling);
    var self = this;
    var fuente = desdeOriginal && a.original ? a.original : a.file;
    this.ajustes = this.ajustes || {};
    this.ajustes[clave] = { host: host, file: a.file };
    this.ajustes[clave].inst = TarjetaAjuste.abrir({
      host: host, file: fuente, esPdf: /pdf$/i.test(fuente.name) || fuente.type === 'application/pdf',
      caja: this.caja, plegada: this.cfg.tipo === 'felicitacion' && !this.cfg.a5, dpiMin: this.cfg.dpiMin, dpiGood: this.cfg.dpiGood,
      precioRevision: this.cfg.repaso ? money(this.cfg.repaso.precio) : '',
      onCerrar: function () { delete self.ajustes[clave]; self.pintarArchivo(clave); },
      onAplicar: function (nuevo, info) {
        var actual = self.archivos[clave];
        self.cerrarAjuste(clave);
        self.cargar(clave, nuevo, {
          anterior: actual, arreglos: (actual.arreglos || []).concat(['ajuste']), ajustado: true,
          original: actual.original || actual.file
        });
      }
    });
    this.pintarArchivo(clave);
  };

  /* DISEÑADOR DE FELICITACIONES: plantillas con texto editable (assets/tarjeta-disenador.js). Genera el exterior (y el interior, si se ha escrito)
     como archivos a medida con sangre y los pone en las casillas de siempre. */
  Tarjetas.prototype.abrirDisenador = function () {
    if (!window.TarjetaDisenador || !(this.cfg.felImg || this.cfg.visitaDis) || this.disenador) return;
    var self = this;
    var host = document.createElement('div'); host.setAttribute('data-disenador', '1');
    document.body.appendChild(host);        // pantalla completa, como los demás editores
    var cerrar = function () { self.devolverPedido(); self.disenador = null; var b = $(self.root, '[data-abrir-disenador]'); if (b) b.hidden = false; self.actualizar(); };
    var comprar = false;
    this.disenador = TarjetaDisenador.abrir({
      host: host, imagenes: this.cfg.felImg || {}, a5: !!this.cfg.a5, visita: !!this.cfg.visitaDis, dosCaras: function () { return self.caras() === 2; }, pedirDosCaras: function () { self.ponDosCaras(); }, onCerrar: cerrar,
      onError: function () { comprar = false; self.busy = false; self.actualizar(); },
      onAplicar: function (r) {
        var seguir = comprar; comprar = false;
        cerrar();
        self.cargar('cara1', r.exterior, { anterior: null, arreglos: ['plantilla'], ajustado: true, original: null }).then(function () {
          if (r.interior) return self.cargar('cara2', r.interior, { anterior: null, arreglos: ['plantilla'], ajustado: true, original: null });
        }).then(function () { if (seguir) { self.busy = false; self.alCarrito(); } });
      }
    });
    // LA PANTALLA ENTERA (Xavi, 21/10): herramientas a la izquierda, mesa en el centro y a la derecha el pedido
    // (cantidad, plazo, precio y «Añadir al carrito»). Esas piezas se mueven de la ficha al editor y vuelven al cerrarlo.
    this.llevarPedido(host);
    var add = $(this.root, '[data-add]');
    this.alAnadir = function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (!self.disenador || self.busy || add.disabled) return;
      comprar = true; self.busy = true; add.disabled = true; add.textContent = 'Preparando tu diseño…';
      self.disenador.aplicar();
    };
    add.addEventListener('click', this.alAnadir, true);
    this.actualizar();
    var b = $(this.root, '[data-abrir-disenador]'); if (b) b.hidden = true;
  };

  var PEDIDO = ['[data-entrega-arriba]', '[data-opciones]', '[data-flash]', '[data-add]', '[data-presupuesto]', '[data-presupuesto-nota]', '[data-pie]'];
  Tarjetas.prototype.llevarPedido = function (host) {
    var destino = host.querySelector('[data-pedido]'), self = this;
    this.movidos = [];
    PEDIDO.forEach(function (sel) {
      var e = self.root.querySelector(sel); if (!e) return;
      var marca = document.createComment('pedido'); e.parentNode.insertBefore(marca, e);
      self.movidos.push([e, marca]); destino.appendChild(e);
    });
    this.root.__extra = host;
  };
  Tarjetas.prototype.devolverPedido = function () {
    var add = $(this.root, '[data-add]');
    if (add && this.alAnadir) add.removeEventListener('click', this.alAnadir, true);
    (this.movidos || []).forEach(function (m) { if (m[1].parentNode) m[1].parentNode.replaceChild(m[0], m[1]); });
    this.movidos = []; this.root.__extra = null; this.alAnadir = null;
  };

  Tarjetas.prototype.montarDisenador = function () {
    if (!(this.cfg.felImg || this.cfg.visitaDis) || !window.TarjetaDisenador) return;
    var bloque = $(this.root, '[data-modo="tengo"] .tjs-bloque'); if (!bloque || $(bloque, '[data-abrir-disenador]')) return;
    var d = document.createElement('div'); d.className = 'tjs-dis-oferta';
    d.innerHTML = this.cfg.visitaDis ? '<b>¿No tienes diseño?</b> Crea tu tarjeta online: elige tu sector y un estilo, escribe tus datos y sube tu logo. <button type="button" class="tjs-fix" data-abrir-disenador>Diseñar mi tarjeta</button>'
      : '<b>¿No tienes diseño?</b> Elige una plantilla y personalízala: cambia los textos, los colores, añade tu foto y ' + (this.cfg.a5 ? 'deja libre el reverso para la dedicatoria. ' : 'escribe el interior. ') +
      '<button type="button" class="tjs-fix" data-abrir-disenador>Diseñar con plantillas</button>';
    bloque.insertBefore(d, bloque.firstChild.nextSibling);
    var self = this;
    d.querySelector('button').addEventListener('click', function () { self.abrirDisenador(); });
    // Entra directo en el editor, como en las camisetas (Xavi, 21/10/2026); con ?editor=no se ve la ficha sin él
    if (!/[?&]editor=no\b/.test(location.search) && !this.abiertoSolo) {
      this.abiertoSolo = true;
      setTimeout(function () { self.abrirDisenador(); }, 250);
    }
  };

  Tarjetas.prototype.cerrarAjuste = function (clave) {
    var e = this.ajustes && this.ajustes[clave];
    if (e && e.inst && e.inst.destruir) e.inst.destruir();
    if (e && e.host && e.host.parentNode) e.host.parentNode.removeChild(e.host);
    if (this.ajustes) delete this.ajustes[clave];
  };

  /* TAMAÑO DEL ARCHIVO (solo tarjetas, Xavi 20/10): avisa si no está a la medida
     con sangre. Buena = medida + 2 mm por lado (89×59 en una de 85×55) o + 3 mm
     (91×61, la de nuestra plantilla). Solo PDF: se mide la página (una imagen no
     trae milímetros fiables). */
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
  var PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
  var pdfjsP = null;
  function cargarPdfjs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfjsP) return pdfjsP;
    pdfjsP = new Promise(function (ok, no) {
      var s = document.createElement('script'); s.src = PDFJS; s.async = true;
      s.onload = function () { try { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; ok(window.pdfjsLib); } catch (e) { no(e); } };
      s.onerror = function () { pdfjsP = null; no(new Error('pdfjs')); };
      document.head.appendChild(s);
    });
    return pdfjsP;
  }

  Tarjetas.prototype.revisaTamano = function () {
    // De momento solo en las tarjetas de felicitación plegadas (21/10/2026): visita y agradecimiento siguen como siempre hasta que Xavi diga lo contrario.
    return !!this.caja && this.cfg.tipo === 'felicitacion';
  };

  Tarjetas.prototype.leerPdfMm = async function (clave) {
    var a = this.archivos[clave];
    if (!a || !this.revisaTamano() || !/pdf$/i.test(a.name)) return;
    try {
      var lib = await cargarPdfjs();
      var buf = await a.file.arrayBuffer();
      var doc = await lib.getDocument({ data: buf }).promise;
      var pg = await doc.getPage(1);
      var vp = pg.getViewport({ scale: 1 });
      a.mm = [vp.width * 25.4 / 72, vp.height * 25.4 / 72];
      if (this.archivos[clave] === a) this.pintarArchivo(clave);
    } catch (e) { /* si no se puede leer, se comprueba en el taller como siempre */ }
  };

  // → {k: 'ok'|'mid'|'low', texto} o null si no se puede saber
  Tarjetas.prototype.avisoTamano = function (a) {
    if (!a || !this.revisaTamano()) return null;
    var W = this.caja.w, H = this.caja.h, nombre = fmt(W / 10, 1) + ' × ' + fmt(H / 10, 1) + ' cm';
    var buenas = [[2, 'con 2 mm de sangre'], [3, 'con 3 mm de sangre']];
    var conSangre = fmt(W + 4, 1) + ' × ' + fmt(H + 4, 1) + ' mm';
    var guia = ' Usa la plantilla de más abajo.';
    var i;
    if (a.mm) {
      var w = a.mm[0], h = a.mm[1], tol = 0.8;
      for (var o = 0; o < 2; o++) {
        var ww = o ? h : w, hh = o ? w : h;
        for (i = 0; i < buenas.length; i++) {
          var s = buenas[i][0] * 2;
          if (Math.abs(ww - (W + s)) <= tol && Math.abs(hh - (H + s)) <= tol) {
            return { k: 'ok', texto: 'Tamaño correcto: ' + nombre + ' ' + buenas[i][1] + '.' };
          }
        }
        if (Math.abs(ww - W) <= tol && Math.abs(hh - H) <= tol) {
          return { k: 'mid', texto: 'Mide justo ' + nombre + ', sin sangre. Se imprime igual, pero el borde puede salir con un filo blanco.' + guia };
        }
      }
      return { k: 'low', texto: 'Tu PDF mide ' + fmt(w, 1) + ' × ' + fmt(h, 1) + ' mm y la tarjeta es de ' + nombre + ' (' + conSangre + ' con sangre). Lo ajustaremos, pero puede recortar bordes.' + guia };
    }
    // imágenes: no traen milímetros fiables, así que solo se revisan los PDF
    return null;
  };

  Tarjetas.prototype.arreglar = async function (clave, tipo) {
    var a = this.archivos[clave];
    if (!a || !a.px || !window.ImgArreglo || this.ocupado) return;
    var caja = $(this.root, '[data-archivo-caja="' + clave + '"]');
    var btn = $(caja, '[data-fix="' + tipo + '"]');
    var texto = btn ? btn.textContent : '';
    this.ocupado = true;
    var soltar = function () { if (btn) { btn.disabled = false; btn.textContent = texto; } };
    if (window.Cargando) {
      Cargando.ocupar(btn, tipo === 'fondo' ? 'Quitando el fondo…' : 'Afinando…');
      soltar = function () { Cargando.libre(btn, texto); };
      await Cargando.pinta();
    } else if (btn) { btn.disabled = true; btn.textContent = 'Un momento…'; }
    try {
      var bmp = await createImageBitmap(a.file);
      // copia en lienzo: hace falta después para el antes/después
      var bmp2 = document.createElement('canvas');
      bmp2.width = bmp.width; bmp2.height = bmp.height;
      bmp2.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0);
      if (bmp.close) bmp.close();
      var res = tipo === 'fondo' ? ImgArreglo.quitarFondo(bmp2) : ImgArreglo.afinarBordes(bmp2, 3);
      if (!res.ok) {
        this.ocupado = false; soltar();
        return this.flash(tipo === 'fondo'
          ? 'No hemos encontrado un fondo liso que quitar en ese archivo.'
          : 'Ese archivo ya tiene tamaño de sobra, no hace falta afinarlo.');
      }
      var base = a.name.replace(/\.[^.]+$/, '');
      var nuevo = await ImgArreglo.aFichero(res.lienzo, base + (tipo === 'fondo' ? '-sin-fondo' : '-afinado') + '.png');
      var comp = null;
      try { comp = ImgArreglo.comparar(bmp2, res.lienzo, 200, 140); } catch (e2) { comp = null; }
      await this.cargar(clave, nuevo, {
        anterior: a, arreglos: (a.arreglos || []).concat([tipo]), comparativa: comp
      });
    } catch (err) {
      this.flash('No hemos podido arreglar esa imagen. Súbela tal cual y ya la miramos nosotros.');
    }
    this.ocupado = false; soltar();
  };

  Tarjetas.prototype.deshacer = function (clave) {
    var a = this.archivos[clave];
    if (!a || !a.anterior) return;
    this.archivos[clave] = a.anterior;
    this.pintarArchivo(clave);
    this.actualizar();
  };

  // ppp a los que se imprimiría ese archivo en la tarjeta
  Tarjetas.prototype.dpi = function (a) {
    if (!a || !a.px || !this.caja) return null;
    var px = a.pxCalidad || a.px;
    var esc = Math.max(this.caja.w / a.px[0], this.caja.h / a.px[1]); // la tarjeta se cubre entera
    var mmAncho = a.px[0] * esc;
    return px[0] / (mmAncho / 25.4);
  };

  Tarjetas.prototype.pintarArchivo = function (clave) {
    var caja = $(this.root, '[data-archivo-caja="' + clave + '"]'), a = this.archivos[clave];
    $(caja, '[data-ficha]').hidden = !a;
    $(caja, '[data-drop]').hidden = !!a;
    if (!a) return;
    $(caja, '[data-nombre]').textContent = a.name;
    var thumb = $(caja, '[data-thumb]');
    thumb.innerHTML = '';
    if (a.thumb) thumb.appendChild(a.thumb);
    else thumb.textContent = (a.name.split('.').pop() || '?').toUpperCase();

    var partes = [], dpi = this.dpi(a);
    if (dpi) {
      // 1748 px en un A5 son 299,99 ppp: el redondeo no puede bajarle la nota
      var k = dpi >= this.cfg.dpiGood - 1 ? 'ok' : (dpi >= this.cfg.dpiMin ? 'mid' : 'low');
      partes.push('<span class="tjs-badge tjs-badge--' + k + '">' +
        (k === 'ok' ? 'Listo para imprenta' : k === 'mid' ? 'Se imprime bien' : 'Poca resolución') + '</span>');
      partes.push(Math.round(dpi) + ' ppp a tamaño ' + (this.cfg.tipo === 'flyer' ? 'de flyer'
        : this.cfg.tipo === 'calendario' ? 'de pegatina' : 'de tarjeta') + '.');
      if (k === 'low') partes.push('<span class="tjs-consejo">A este tamaño se notará algo pixelado. Si tienes el original en PDF o AI, mándalo mejor.</span>');
      a.nota = a.px[0] + '×' + a.px[1] + ' px · ' + Math.round(dpi) + ' ppp';
    } else {
      partes.push('<span class="tjs-badge tjs-badge--ok">Archivo de imprenta</span> Lo comprobamos antes de producir.');
      a.nota = 'PDF o vectorial';
    }
    var ed = this.ajustes && this.ajustes[clave];
    if (ed && ed.file !== a.file) { this.cerrarAjuste(clave); ed = null; }
    if (clave !== 'logo' && a.ajustado) {
      partes.push('<span class="tjs-badge tjs-badge--ok">Ajustada a la tarjeta</span> Con sangre (' + fmt(this.caja.w + 4, 1) + ' × ' + fmt(this.caja.h + 4, 1) + ' mm), lista para imprenta.');
    }
    var ta = clave !== 'logo' && !a.ajustado ? this.avisoTamano(a) : null;
    if (ta) {
      partes.push('<span class="tjs-badge tjs-badge--' + ta.k + '">' + (ta.k === 'ok' ? 'Medida correcta' : 'Revisa la medida') + '</span> ' + ta.texto);
      var serv = this.cfg.repaso, rep = $(this.root, '[data-repaso]');
      if (ta.k !== 'ok' && serv && rep) {
        partes.push(rep.checked
          ? '<span class="tjs-consejo">✓ Has contratado la revisión: un diseñador lo ajustará y te mandará la prueba.</span>'
          : '<span class="tjs-consejo">¿Prefieres que lo arreglemos nosotros? <button type="button" class="tjs-link" data-contratar-revision>Contratar la revisión de archivos · ' + money(serv.precio) + '</button></span>');
      }
      a.nota = (a.nota ? a.nota + ' · ' : '') + (ta.k === 'ok' ? 'medida ok' : 'medida: revisar');
    }
    if (clave !== 'logo' && window.TarjetaAjuste && this.revisaTamano() && !ed && /png|jpe?g|webp|pdf/i.test(a.file.type + ' ' + a.name)) {
      partes.push('<button type="button" class="tjs-link" data-abrir-ajuste="' + clave + '"' + (a.ajustado ? ' data-original="1"' : '') + '>' +
        (a.ajustado ? 'Ajustar otra vez' : 'Ver en la tarjeta y ajustar') + '</button>');
    }
    if (a.transparente === false && clave === 'logo') {
      partes.push('<span class="tjs-badge tjs-badge--mid">Tiene fondo</span>');
    }
    $(caja, '[data-info]').innerHTML = partes.join(' ');

    var fixes = $(caja, '[data-fixes]');
    if (fixes && window.ImgArreglo) {
      var hechos = a.arreglos || [];
      var sugFondo = clave === 'logo' && a.transparente === false && hechos.indexOf('fondo') === -1;
      var sugBordes = hechos.indexOf('bordes') === -1 && a.px && a.px[0] <= 1500 &&
        dpi && dpi < this.cfg.dpiMin;
      var bf = $(caja, '[data-fix="fondo"]'), bb = $(caja, '[data-fix="bordes"]'), bd = $(caja, '[data-deshacer]');
      if (bf) bf.hidden = !sugFondo;
      if (bb) bb.hidden = !sugBordes;
      if (bd) bd.hidden = !a.anterior;
      var comp = $(caja, '[data-compara]');
      if (comp) {
        comp.hidden = !a.comparativa;
        if (a.comparativa) {
          var ca = $(comp, '[data-antes]'), cd2 = $(comp, '[data-ahora]');
          ca.innerHTML = ''; ca.appendChild(a.comparativa.antes);
          cd2.innerHTML = ''; cd2.appendChild(a.comparativa.despues);
        }
      }
      fixes.hidden = !(sugFondo || sugBordes || a.anterior);
    }
  };

  /* ---------- estado ---------- */
  Tarjetas.prototype.datos = function () {
    var out = [];
    $$(this.root, '[data-dato]').forEach(function (i) {
      var v = i.value.trim();
      if (v) out.push([i.dataset.dato, v]);
    });
    return out;
  };

  /* LA PLANTILLA PARA DISEÑAR.
   *
   * Xavi: «en temas de imprenta como las tarjetas puedes crear las plantillas
   * en pdf con las líneas de corte sangre y seguridad? Asi se las puede bajar
   * el cliente para hacer el diseño». El archivo que llega montado a medida es
   * el que no hay que rehacer en el taller, y eso es tiempo de preproducción
   * que no se paga.
   *
   * La plantilla se elige por la MEDIDA, no por la ficha: así una ficha nueva
   * con una medida que ya existe la hereda sin tocar nada, y una con medida
   * rara no enseña una plantilla que no es la suya — el bloque se queda oculto.
   */
  Tarjetas.prototype.pintarPlantilla = function () {
    var caja = $(this.root, '[data-plantilla]');
    if (!caja) return;
    var p = this.caja && (this.cfg.plantillas || {})[Math.round(this.caja.w) + 'x' + Math.round(this.caja.h)];
    if (!p || !p.guias) { caja.hidden = true; caja.innerHTML = ''; return; }
    caja.hidden = false;
    caja.innerHTML = '<b>¿Lo diseñas tú?</b> Bájate la plantilla y trabaja encima: lleva marcado el corte, ' +
      'la sangre y hasta dónde puedes acercar el texto. ' +
      '<a href="' + p.guias + '" download>Plantilla con guías</a>' +
      (p.limpia ? ' · <a href="' + p.limpia + '" download>plantilla limpia</a>' : '') +
      ' <span class="tjs-muted">(PDF)</span>';
  };

  Tarjetas.prototype.pdfDosCaras = function () {
    var c = $(this.root, '[data-pdf2]');
    return !!(c && c.checked && this.archivos.cara1);
  };

  /* el editor lo pide cuando el cliente pone algo en la cara de detrás: se marca «A 2 caras» (si esa combinación existe) */
  Tarjetas.prototype.ponDosCaras = function () {
    if (this.iCaras < 0 || !this.sel) return;
    var i = this.iCaras, dos = this.valores[i].filter(function (x) { return carasDe(x) === 2; })[0];
    if (!dos || this.sel[i] === dos || !this.varianteCon(i, dos)) return;
    this.sel[i] = dos; this.pintarOpciones(); this.actualizar();
  };

  Tarjetas.prototype.actualizar = function () {
    var r = this.root, v = this.variante(), modo = this.modo();
    if (this.disenador && this.disenador.alCambiarCaras) { var dosAhora = this.caras() === 2; if (this.dosVisto !== dosAhora) { this.dosVisto = dosAhora; this.disenador.alCambiarCaras(); } }
    $(r, '[data-modo="tengo"]').hidden = modo !== 'tengo';
    $(r, '[data-modo="encargo"]').hidden = modo !== 'encargo';
    var md = this.medida();
    this.caja = md.caja;
    var med = $(r, '[data-medida]');
    if (med) med.textContent = md.texto;
    /* La cara de detrás: en tarjetas va sin coste; en flyers depende de si
       ha elegido 1 o 2 caras, y cuesta distinto, así que se dice. */
    var caras = this.caras();
    /* A 1 cara no hay cara de detrás que subir ni PDF de 2 caras (Xavi, 14/10): se esconden y, si ya había algo, se quita para que no bloquee */
    var caja2 = $(r, '[data-archivo-caja="cara2"]'), pdf2 = $(r, '[data-pdf2]'), pdf2L = pdf2 && pdf2.closest('label');
    var una = caras === 1;
    if (caja2) caja2.hidden = una;
    if (pdf2L) pdf2L.hidden = una;
    if (una) {
      if (pdf2 && pdf2.checked) pdf2.checked = false;
      if (this.archivos.cara2) { delete this.archivos.cara2; this.pintarArchivo('cara2'); }
    }
    var n2 = $(r, '[data-cara2-nota]');
    if (n2) n2.textContent = caras === 1 ? 'Solo si lo quieres a 2 caras (elígelo arriba)'
      : caras === 2 ? 'Has elegido 2 caras: súbela aquí' : 'Opcional, sin coste extra';
    this.pintarPlantilla();
    var nt = $(r, '[data-notas-t]');
    if (nt) nt.textContent = (modo === 'tengo' ? (this.cfg.paso ? '3' : '2') : '4') + ' · Indicaciones (opcional)';
    this.pintarBase();

    ['cara1', 'cara2', 'logo'].forEach(function (k) {
      if (this.archivos[k]) this.pintarArchivo(k);
    }, this);

    var falta = null;
    if (modo === 'tengo') {
      if (!this.archivos.cara1 && this.disenador) falta = null;      // el diseño se genera al pulsar «Añadir al carrito»
      else if (!this.archivos.cara1) falta = this.cfg.tipo === 'calendario'
        ? 'Para continuar, sube tu diseño para la pegatina de la base.'
        : 'Para continuar, sube la cara de delante ' + this.pal.de + '.';
      /* 1 cara con dos archivos, o 2 caras con uno: se le dice antes de pagar
         en vez de descubrirlo en el taller. */
      else if (this.pdfDosCaras() && this.archivos.cara2) falta = 'Has marcado que tu PDF ya lleva las 2 caras y has subido también la de detrás: quita una de las dos cosas.';
      else if (this.pdfDosCaras() && caras === 1) falta = 'Tu PDF lleva las 2 caras: elige arriba impresión a 2 caras, o desmarca la casilla.';
      else if (caras === 1 && this.archivos.cara2) falta = 'Has subido la cara de detrás pero has elegido impresión a 1 cara: cámbialo arriba a 2 caras, o quita la de detrás.';
      else if (caras === 2 && !this.archivos.cara2 && !this.pdfDosCaras()) falta = 'Has elegido impresión a 2 caras: sube también la cara de detrás, o cámbialo arriba a 1 cara.';
    } else if (!this.datos().length) {
      falta = 'Para continuar, dinos al menos el nombre o la empresa que va en ' + (this.cfg.tipo === 'flyer' ? 'el flyer' : 'la tarjeta') + '.';
    }

    var repaso = $(r, '[data-repaso]'), wrap = $(r, '[data-repaso-wrap]');
    var serv = this.cfg.repaso;
    if (wrap) {
      wrap.hidden = modo !== 'tengo' || !serv || !this.archivos.cara1;
      wrap.classList.toggle('is-marcado', !!(repaso && repaso.checked));
      var precio = $(r, '[data-repaso-precio]');
      if (precio && serv) precio.textContent = '· ' + money(serv.precio);
    }
    var extra = (modo === 'tengo' && repaso && repaso.checked && serv) ? serv.precio : 0;
    var lineas = this.uds();   // 1 salvo en calendarios
    this.pintarTramos();

    var btn = $(r, '[data-add]');
    if (!this.busy && window.Cargando) Cargando.libre(btn);
    btn.disabled = !!falta || !v || this.busy;
    var bPres2 = $(r, '[data-presupuesto]');
    if (bPres2) bPres2.disabled = !!falta || !v || this.busy;
    var rec = this.recargo();
    var baseEur = this.cfg.paso ? this.precioUd(lineas) * lineas : this.precioBase();
    if (!this.busy) btn.textContent = v ? 'Añadir al carrito · ' + money(baseEur + extra + (rec ? rec.precio : 0)) : 'Añadir al carrito';

    var pie = $(r, '[data-pie]');
    if (pie) {
      if (falta) pie.textContent = falta;
      else if (modo === 'encargo') pie.textContent = 'Te mandamos dos propuestas por email en 24-48 h laborables. No imprimimos nada hasta que nos des el visto bueno.';
      else {
        var uds = this.cantidad();
        var cadaUno = this.cfg.paso ? money(this.precioUd(uds)) : porUd(this.precioBase(), uds);
        pie.textContent = (uds ? uds + ' ' + this.pal.varias + ' a ' + cadaUno +
          (this.cfg.tipo === 'tarjeta' ? ' cada una. ' : ' cada uno. ') : '') +
          (this.cfg.tipo !== 'tarjeta'
            ? 'Lo revisamos antes de imprimir y, si vemos algo raro, te escribimos.'
            : 'Antes de producir te mandamos la prueba para que la apruebes.');
      }
    }
  };

  /* LA PREVIA SOBRE LA BASE (calendarios). El calendario de frente: la hoja
     del mes arriba, con sus anillas, y abajo la cara de la base triangular,
     que es donde va la pegatina de 10 × 3 cm. Se dibuja en milímetros con las
     medidas de la ficha (11 × 13,8 cm) para que el tamaño del logo sea el de
     verdad respecto al calendario. */
  Tarjetas.prototype.pintarBase = function () {
    var lz = $(this.root, '[data-base]');
    if (!lz) return;
    var a = this.archivos.cara1;
    lz.hidden = !(a && a.thumb);
    if (lz.hidden) return;
    var W = 130, H = 160, css = Math.min(380, (lz.parentNode.clientWidth || 380)), dpr = window.devicePixelRatio || 1;
    var k = css / W;
    lz.width = Math.round(css * dpr); lz.height = Math.round(H * k * dpr);
    lz.style.width = css + 'px';
    var c = lz.getContext('2d');
    c.setTransform(dpr * k, 0, 0, dpr * k, 0, 0);
    c.clearRect(0, 0, W, H);
    var x0 = 10, y0 = 8, ancho = 110, alto = 138, base = 36;
    // sombra y cuerpo
    c.fillStyle = 'rgba(0,0,0,.18)'; c.fillRect(x0 + 1.5, y0 + 2, ancho, alto);
    c.fillStyle = '#ffffff'; c.fillRect(x0, y0, ancho, alto);
    c.strokeStyle = '#c9c9cf'; c.lineWidth = 0.4; c.strokeRect(x0, y0, ancho, alto);
    // la hoja del mes: cabecera y rejilla
    c.fillStyle = '#e9e9ee'; c.fillRect(x0 + 6, y0 + 10, ancho - 12, 10);
    c.fillStyle = '#9a9aa3'; c.font = 'bold 6px sans-serif'; c.textAlign = 'center';
    c.fillText('ENERO 2027', x0 + ancho / 2, y0 + 17);
    c.strokeStyle = '#dcdce2';
    for (var f = 0; f <= 6; f++) { c.beginPath(); c.moveTo(x0 + 6, y0 + 24 + f * 11); c.lineTo(x0 + ancho - 6, y0 + 24 + f * 11); c.stroke(); }
    for (var g = 0; g <= 7; g++) { c.beginPath(); c.moveTo(x0 + 6 + g * (ancho - 12) / 7, y0 + 24); c.lineTo(x0 + 6 + g * (ancho - 12) / 7, y0 + 24 + 66); c.stroke(); }
    // anillas
    c.strokeStyle = '#8a8a92'; c.lineWidth = 0.9;
    for (var h = 0; h < 14; h++) { var ax = x0 + 10 + h * 7; c.beginPath(); c.moveTo(ax, y0 - 2); c.lineTo(ax, y0 + 4); c.stroke(); }
    // la base, con la pegatina de 100 × 30 centrada
    var by = y0 + alto - base;
    c.fillStyle = '#f4f4f6'; c.fillRect(x0, by, ancho, base);
    c.strokeStyle = '#c9c9cf'; c.lineWidth = 0.4; c.strokeRect(x0, by, ancho, base);
    var px = x0 + (ancho - 100) / 2, py = by + (base - 30) / 2;
    c.save();
    c.beginPath(); c.rect(px, py, 100, 30); c.clip();
    c.fillStyle = '#ffffff'; c.fillRect(px, py, 100, 30);
    // el diseño cubre la pegatina entera, como se imprime
    var t = a.thumb, esc = Math.max(100 / t.width, 30 / t.height);
    var dw = t.width * esc, dh = t.height * esc;
    c.drawImage(t, px + (100 - dw) / 2, py + (30 - dh) / 2, dw, dh);
    c.restore();
    c.strokeStyle = 'rgba(0,0,0,.25)'; c.setLineDash([1.2, 1]); c.strokeRect(px, py, 100, 30); c.setLineDash([]);
  };

  /* ---------- carrito ---------- */
  Tarjetas.prototype.alCarrito = function (presupuesto) {
    var self = this, v = this.variante(), modo = this.modo();
    if (!v || this.busy) return;
    var r = this.root, btn = $(r, '[data-add]');
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var campos = [['id', v.id], ['quantity', this.uds()]];

    if (modo === 'encargo') {
      this.datos().forEach(function (d) { campos.push(['properties[' + d[0] + ']', d[1]]); });
      if (this.estilo) {
        var e = ESTILOS.filter(function (x) { return x.id === self.estilo; })[0];
        campos.push(['properties[Estilo]', e.t + ' — ' + e.d]);
      }
    }
    var notas = $(r, '[data-notas]').value.trim();
    if (notas) campos.push(['properties[Indicaciones]', notas]);
    if (modo === 'tengo' && this.pdfDosCaras()) campos.push(['properties[Caras en el PDF]', 'Sí: el PDF lleva las 2 caras (página 1 delante, página 2 detrás)']);

    /* Solo viajan los archivos del camino elegido: si el cliente cambió de
       "tengo el diseño" a "hacédmelo vosotros", las caras que subió antes se
       quedan fuera del pedido. */
    var etiquetas = { cara1: 'Cara de delante', cara2: 'Cara de detrás', logo: 'Logo' };
    var claves = (modo === 'tengo' ? ['cara1', 'cara2'] : ['logo'])
      .filter(function (k) { return !!self.archivos[k]; });

    var res = [], arr = [];
    claves.forEach(function (k) {
      var a = self.archivos[k];
      if (a.nota) res.push(etiquetas[k] + ': ' + a.nota);
      (a.arreglos || []).forEach(function (x) {
        arr.push(etiquetas[k] + ': ' + (x === 'fondo' ? 'fondo quitado en la web' : 'bordes afinados en la web'));
      });
    });
    if (res.length) campos.push(['properties[_resolucion]', res.join(' · ')]);
    if (arr.length) campos.push(['properties[_arreglos]', arr.join(' · ')]);

    var repaso = $(r, '[data-repaso]');
    var conRepaso = !!(modo === 'tengo' && repaso && repaso.checked && this.cfg.repaso);
    if (conRepaso) campos.push(['properties[Repaso del diseñador]', 'Sí, revisadlo y mandadme la prueba antes de imprimir']);
    /* EL PLAZO VIAJA CON EL PEDIDO: la fecha que vio el cliente al pagar llega al taller escrita, y el recargo va como línea aparte. */
    var recP = this.cfg.plazos ? this.recargo() : null;
    if (this.cfg.plazos && window.Entrega && this.cfg.entrega && Entrega.textoPlazo) {
      var plz = this.plazo || 'eco';
      var impP = (this.cantidad() || 0) * (this.caras() || 1);
      campos.push(['properties[Plazo]', (plz === 'express' ? 'EXPRESS · URGENTE' : plz === 'eco' ? 'Económico' : 'Normal') + ' · ' +
        Entrega.textoPlazo(this.cfg.entrega, plz, null, impP).replace(/<[^>]+>/g, '') + ' (fecha estimada, no garantizada)']);
    }
    var extras = [];
    var lAC = this.libreInfo();
    if (lAC) {          // «otra cantidad»: la variante del escalón de abajo + el suplemento (1 € por unidad) con lo que sobra
      var detalle = lAC.uds.toLocaleString('es-ES') + ' uds = ' + lAC.base.toLocaleString('es-ES') + ' + ' + lAC.sobran.toLocaleString('es-ES') + ' uds extra a ' + porUd(lAC.unit, 1);
      campos.push(['properties[Cantidad a medida]', detalle]);
      if (lAC.extraEur > 0 && this.cfg.suplemento) extras.push({ id: this.cfg.suplemento, quantity: lAC.extraEur, properties: { 'Unidades extra': lAC.sobran + ' uds × ' + porUd(lAC.unit, 1) + ' (sobre el pack de ' + lAC.base + ')' } });
    }
    if (conRepaso) extras.push({ id: this.cfg.repaso.id, quantity: 1 });
    if (recP) extras.push({ id: recP.id, quantity: 1 });

    /* PRESUPUESTO LISTO PARA PAGAR (Xavi, 07/10): las mismas líneas y archivos, pero a un pedido borrador del Worker en vez de al carrito. */
    if (presupuesto === true) {
      var bP = $(r, '[data-presupuesto]'), notaP = $(r, '[data-presupuesto-nota]'), antesP = bP ? bP.textContent : '';
      if (!window.Presupuesto || !this.cfg.presupuestoUrl || !bP) return;
      this.busy = true; bP.disabled = true; bP.textContent = 'Preparando el presupuesto…';
      var fdP = new FormData();
      campos.forEach(function (f) { fdP.append(f[0], f[1]); });
      claves.forEach(function (k) { var a = self.archivos[k]; fdP.append('properties[' + etiquetas[k] + ']', a.file, a.name); });
      claves.forEach(function (k) { var a = self.archivos[k]; if (a.original) fdP.append('properties[' + etiquetas[k] + ' (original)]', a.original, a.original.name); });
      var datosP = Presupuesto.desdeForm(fdP, extras);
      Presupuesto.crear(this.cfg.presupuestoUrl, { titulo: (document.querySelector('h1') || document).textContent.replace(/\s+/g, ' ').trim().slice(0, 120), nota: '', lineas: datosP.lineas, ficheros: datosP.ficheros })
        .then(function (pres) {
          var total = pres.total ? money(Math.round(parseFloat(pres.total) * 100)) : '';
          pres.totalTexto = total ? total + ' IVA incl.' : '';
          var titulo = (document.querySelector('h1') || document).textContent.replace(/\s+/g, ' ').trim();
          var texto = 'Presupuesto de Imprimirlo · ' + titulo + '\n' + (total ? 'Precio: ' + total + ' IVA incl.\n' : '') + (pres.landing ? 'Mira el montaje y págalo aquí: ' + pres.landing : 'Págalo aquí: ' + pres.url);
          var copiado = false;
          var fin = function () { Presupuesto.mostrar(notaP, pres, texto, copiado); self.busy = false; bP.textContent = antesP; self.actualizar(); };
          if (!Presupuesto.esMovil() && navigator.clipboard) navigator.clipboard.writeText(texto).then(function () { copiado = true; fin(); }, fin); else fin();
        })
        .catch(function (e) {
          self.busy = false; bP.textContent = antesP; self.actualizar();
          self.flash((e && e.message) || 'No se ha podido preparar el presupuesto. Inténtalo otra vez o escríbenos por WhatsApp.');
        });
      return;
    }

    this.busy = true;
    var textoSubida = claves.length > 1 ? 'Subiendo los archivos' : 'Subiendo el archivo';
    if (window.Cargando) Cargando.ocupar(btn, textoSubida + '…', true);
    else { btn.disabled = true; btn.textContent = textoSubida + '…'; }
    var fd = new FormData();
    campos.forEach(function (f) { fd.append(f[0], f[1]); });
    claves.forEach(function (k) {
      var a = self.archivos[k];
      fd.append('properties[' + etiquetas[k] + ']', a.file, a.name);
      if (a.original) fd.append('properties[' + etiquetas[k] + ' (original)]', a.original, a.original.name);
    });

    // con XHR sí se sabe cuánto se ha enviado; con fetch, no
    var envio = window.Cargando
      ? Cargando.subir(raiz + 'cart/add.js', fd, function (p) {
          if (p >= 100) Cargando.ocupar(btn, 'Guardando…');
          else Cargando.pct(btn, p, textoSubida);
        })
      : fetch(raiz + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });

    envio
      .then(function (res2) {
        if (!res2.ok) throw new Error('carrito');
        if (window.Cargando) Cargando.ocupar(btn, 'Vamos al carrito…');
        if (!extras.length) return null;
        return fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: extras })
        });
      })
      .then(function () { window.location.href = raiz + 'cart'; })
      .catch(function () {
        self.busy = false;
        self.flash('No se ha podido añadir al carrito. Inténtalo otra vez o escríbenos por WhatsApp.');
        self.actualizar();
      });
  };

  function init() {
    document.querySelectorAll('[data-tarjetas]').forEach(function (el) { if (!el._tjs) el._tjs = new Tarjetas(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();